import * as url from './url_helper';

export const getMilestoneConfigOperation = async (payload: any) => {
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
      user = JSON.parse(getAuthUser);
    }
  
    const query = `query{
        getMilestonesData(Milestone: {
          userId: ${user.id}
          OperationType :"${payload}"    
        }) {
                OperationType
                OperationName
                userId
                text
                dataField
                visibleInTable
                visibleInModalHeader
                visibleInMiddle
                visibleInModalFooter
                isMilestone          
                visibleInModalBody
                visibleInModalTotal
                showInFilters
                order
                hidden
                data {
                  id
                  name
                }
        }
      
      }`;

    const response = await fetch(url.API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query,
      }),
    }).then((res) => res.json());
    return response.data.getMilestonesData;
  };